import React from 'react';
import { GameOverMessage } from '../types';

interface GameOverModalProps {
  gameOverMessage: GameOverMessage | null;
  onGenerateTranscript: () => void;
  onReturnToMenu: () => void;
}

const GameOverModal: React.FC<GameOverModalProps> = ({
  gameOverMessage,
  onGenerateTranscript,
  onReturnToMenu
}) => {
  if (!gameOverMessage) return null;

  return (
    <div className="game-over-message">
      <h2>{gameOverMessage.title}</h2>
      <p>{gameOverMessage.message}</p>
      <div className="game-over-actions">
        <button onClick={onGenerateTranscript} className="share-btn">
          <i className="lni lni-download"></i>
          Download Journey Record
        </button>
        <button onClick={onReturnToMenu} className="return-btn">
          <i className="lni lni-home"></i>
          Return to Spirit Realm
        </button>
      </div>
    </div>
  );
};

export default GameOverModal; 